import { PageLink } from "../../../../../_metronic/layout/core"
import { EMatchingPaymentTicketStatus } from "../../../../../types/enums"
import { matchingCapabilities, MatchingPaymentActiveTicketsFilters, MatchingPaymentTicketListObject } from "../../core/_models"


const defaultList: MatchingPaymentTicketListObject = {}
// Активные пополнения помещаются на одну страницу (backend max — 500).
// Блок пагинации остаётся в коде и появится сам, если тикетов станет больше.
const perPage = 500

export const breadcrumbs: Array<PageLink> = [
  {
    title: 'Активные пополнения',
    path: '/matching/payment/active',
    isSeparator: false,
    isActive: true,
    roles: matchingCapabilities.canViewActivePayments,
  },
  {
    title: 'Завершённые пополнения',
    path: '/matching/payment/finished',
    isSeparator: false,
    isActive: false,
    roles: matchingCapabilities.canViewFinishedPayments,
  },
]

const relevantStatusList: Array<EMatchingPaymentTicketStatus> = [
  EMatchingPaymentTicketStatus.WAITING_FOR_SMS,
  EMatchingPaymentTicketStatus.WAITING_FOR_MERCHANT,
  EMatchingPaymentTicketStatus.WAITING_FOR_ACTION,
  EMatchingPaymentTicketStatus.NOT_CONFIRMED,
  EMatchingPaymentTicketStatus.PAYMENT_PENDING,
  // CPAYMENT-1616: авто-проверка чека — промежуточный шаг перед ручной проверкой;
  // тикеты в нём активны и должны быть видны оператору наравне с FILES_VERIFICATION.
  EMatchingPaymentTicketStatus.FILES_AUTO_VERIFICATION,
  EMatchingPaymentTicketStatus.FILES_VERIFICATION,
]

const defaultFilters: MatchingPaymentActiveTicketsFilters = {
  search: '',
}

export const matchingActivePaymentsConfig = {
  breadcrumbs,
  defaultList,
  perPage,
  relevantStatusList,
  defaultFilters,
}